// extracted by mini-css-extract-plugin
export default {"reasonModal":"ReasonModal_reasonModal__x+QQ+"};